/* PB Liquids How-to — de bolletjes onder de stappen, op een telefoon.

   De rij zelf is CSS: scroll-snap, waar de browser het vegen, de vaart en het
   terugveren van doet. Dit script doet er twee dingen omheen, precies zoals
   pb-pop-stars.js dat voor de productslider doet: het zet het bolletje van de
   stap die in beeld staat aan, en het laat een klik op een bolletje naar die
   stap schuiven.

   Op desktop staan de stappen onder elkaar en zijn de bolletjes verborgen
   (assets/pb-liquids-howto-desktop.css); het script luistert dan naar een rij
   die niet scrolt en doet dus niets. Zonder JS blijft de rij gewoon veegbaar en
   blijft het eerste bolletje aan.

   Wat het boven het breekpunt (data-pbht-break op de slider, dezelfde
   instelling als de stylesheet) wél doet: de tabstop van de rij weghalen en de
   carrousel-rol van de sectie — daar staat alles onder elkaar en valt er niets
   te vegen, dus een tabstop die niets doet en een aankondiging van een
   carrousel die er geen is kloppen niet meer. Smaller wordt het venster, dan
   komen ze terug. (Tot 8 september 2026 deed pb-liquids-desk.js dat, maar dat
   script is er alleen op de pre-sale pagina.) */
(function () {
  if (window.PBLiquidsHowto) {
    window.PBLiquidsHowto.init(document);
    return;
  }

  var controllers = new WeakMap();

  function findSliders(root) {
    var sliders = [];

    if (root.matches && root.matches('[data-pbht-slider]')) sliders.push(root);
    if (root.querySelectorAll) {
      sliders = sliders.concat(Array.prototype.slice.call(root.querySelectorAll('[data-pbht-slider]')));
    }

    return sliders;
  }

  /* De carrousel-semantiek aan (telefoon) of uit (desktop). De waarden die
     teruggezet worden staan letterlijk zo in sections/pb-liquids-howto.liquid. */
  function flatten(slider, track, flat) {
    if (flat) {
      track.setAttribute('tabindex', '-1');
      slider.removeAttribute('aria-roledescription');
      return;
    }

    track.setAttribute('tabindex', '0');
    slider.setAttribute('aria-roledescription', 'carrousel');
  }

  function createController(slider) {
    var track = slider.querySelector('[data-pbht-track]');
    var steps = Array.prototype.slice.call(slider.querySelectorAll('[data-pbht-step]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-pbht-dot]'));
    if (!track) return null;

    /* Het breekpunt, als de sectie er een meegeeft. Zonder (of zonder
       matchMedia) blijft de rij altijd een carrousel, zoals voorheen. */
    var breakpoint = parseInt(slider.getAttribute('data-pbht-break'), 10);
    var query = null;
    if (breakpoint && window.matchMedia) {
      query = window.matchMedia('(min-width: ' + breakpoint + 'px)');
    }

    function onWidth() {
      flatten(slider, track, query.matches);
    }

    if (query) {
      if (query.addEventListener) {
        query.addEventListener('change', onWidth);
      } else if (query.addListener) {
        query.addListener(onWidth);
      }
      onWidth();
    }

    function unwatch() {
      if (!query) return;
      if (query.removeEventListener) {
        query.removeEventListener('change', onWidth);
      } else if (query.removeListener) {
        query.removeListener(onWidth);
      }
      flatten(slider, track, false);
    }

    /* De bolletjes zijn er alleen als er iets te wisselen valt; zonder blijft
       er van de controller alleen het breekpunt over. */
    if (steps.length < 2 || dots.length !== steps.length) {
      return {
        destroy: function () {
          unwatch();
          controllers.delete(slider);
        },
        selectStep: function () {},
      };
    }

    var current = -1;

    function mark(index) {
      if (index === current || index < 0 || index >= dots.length) return;
      current = index;

      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    /* Welke stap in beeld staat, gemeten aan het midden van de rij: de stap
       waarvan het midden daar het dichtst bij ligt. Dat klopt ook halverwege
       een veeg en tijdens het terugveren. */
    function readPosition() {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var nearest = 0;
      var shortest = Infinity;

      steps.forEach(function (step, i) {
        var distance = Math.abs(step.offsetLeft + step.offsetWidth / 2 - middle);
        if (distance < shortest) {
          shortest = distance;
          nearest = i;
        }
      });

      mark(nearest);
    }

    var frame = 0;
    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        readPosition();
      });
    }

    function goTo(index) {
      var step = steps[index];
      if (!step) return;

      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = step.offsetLeft - track.offsetLeft;

      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: still ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }

      /* Meteen aanzetten in plaats van op de scroll te wachten: het bolletje
         moet direct antwoorden op de tik. */
      mark(index);
    }

    function onDotClick(event) {
      goTo(dots.indexOf(event.currentTarget));
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', onDotClick);
    });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    readPosition();

    return {
      destroy: function () {
        dots.forEach(function (dot) {
          dot.removeEventListener('click', onDotClick);
        });
        track.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (frame) window.cancelAnimationFrame(frame);
        unwatch();
        controllers.delete(slider);
      },
      selectStep: function (step) {
        var index = steps.indexOf(step);
        if (index >= 0) goTo(index);
      },
    };
  }

  /* Een video die vanzelf speelt is voor wie liever geen beweging ziet een
     stilstaand beeld met knoppen: autoplay eraf, pauze, en de knoppen aan
     zodat hij alsnog te starten is. */
  function settleVideos(root) {
    if (!root.querySelectorAll) return;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Array.prototype.forEach.call(root.querySelectorAll('.pb-liquids-howto__image--video'), function (video) {
      video.removeAttribute('autoplay');
      video.setAttribute('controls', '');
      if (typeof video.pause === 'function') video.pause();
    });
  }

  function init(root) {
    settleVideos(root);
    findSliders(root).forEach(function (slider) {
      if (controllers.has(slider)) return;

      var controller = createController(slider);
      if (controller) controllers.set(slider, controller);
    });
  }

  function destroy(root) {
    findSliders(root).forEach(function (slider) {
      var controller = controllers.get(slider);
      if (controller) controller.destroy();
    });
  }

  window.PBLiquidsHowto = {
    init: init,
    destroy: destroy,
  };

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  /* In de theme-editor schuift de rij naar de stap waarvan je het blok
     aanklikt, zodat je ziet wat je aan het bewerken bent. */
  document.addEventListener('shopify:block:select', function (event) {
    var step = event.target.closest ? event.target.closest('[data-pbht-step]') : null;
    var slider = step && step.closest('[data-pbht-slider]');
    var controller = slider && controllers.get(slider);

    if (controller) controller.selectStep(step);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
})();
